var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAcademy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 18.75C22.5 19.2 22.8 19.5 23.25 19.5C23.7 19.5 24 19.2 24 18.75V9C24 8.55 23.7 8.25 23.25 8.25C22.8 8.25 22.5 8.55 22.5 9V18.75Z",
    fill: "#0350A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.625 2.32502L0.375 8.32503C0.15 8.47503 0 8.70003 0 9.00003C0 9.30002 0.15 9.52502 0.375 9.67502L11.625 15.675C11.775 15.75 11.85 15.75 12 15.75C12.15 15.75 12.225 15.75 12.3 15.675L23.55 9.67502C23.775 9.52502 23.925 9.30002 23.925 9.00003C23.925 8.70003 23.775 8.47503 23.55 8.32503L12.3 2.32502C12.075 2.17502 11.85 2.17502 11.625 2.32502ZM22.6906 9.00002L11.9625 3.27836L1.23438 9.00002L11.9625 14.7217L22.6906 9.00002Z",
    fill: "#0350A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5751 17.8038C13.0547 18.1625 12.4695 18.25 12 18.25C11.5305 18.25 10.9453 18.1625 10.4249 17.8038L5.5 15.2268V16.5C5.5 17.1291 6.03596 17.9913 7.32843 18.7633C8.56624 19.5027 10.2633 20 12 20C13.7367 20 15.4338 19.5027 16.6716 18.7633C17.964 17.9913 18.5 17.1291 18.5 16.5V15.2268L13.5751 17.8038ZM13.05 16.95C12.75 17.175 12.375 17.25 12 17.25C11.625 17.25 11.25 17.175 10.95 16.95L4.5 13.575V16.5C4.5 18.825 8.175 21 12 21C15.825 21 19.5 18.825 19.5 16.5V13.575L13.05 16.95Z",
    fill: "#0350A2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademy);
export default __webpack_public_path__ + "static/media/academy.a07bb834844345da4e24db451a9d3457.svg";
export { ForwardRef as ReactComponent };